import { render } from "./DashboardReservedCollected.vue?vue&type=template&id=98d2a782&scoped=true&ts=true"
import script from "./DashboardReservedCollected.vue?vue&type=script&lang=ts"
export * from "./DashboardReservedCollected.vue?vue&type=script&lang=ts"

import "./DashboardReservedCollected.vue?vue&type=style&index=0&id=98d2a782&lang=scss&scoped=true"

import exportComponent from "/home/node/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98d2a782"]])

export default __exports__